<template>
  <div :class="classContents">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.lic.type') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="license.type" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.server.mac.addr') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="license.macAddress" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.count.cpu.core') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="license.numberOfCpu" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <!-- BEGIN::Added.by.KWShin.2025.04.18. -->
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.count.inst') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="license.numberOfInst" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <!-- END::Added.by.KWShin.2025.04.18. -->
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.end.date') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="endDate" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.feature.allowed') }}</p>
          </v-col>
          <v-col cols="9"><v-text-field :value="licenseFeatures" outlined dense hide-details readonly></v-text-field></v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <p class="label">{{ $t('admin.lic.serial') }}</p>
          </v-col>
          <v-col cols="9">
            <v-textarea v-model="serial" @input="changeSerial" height="90" :label="$t('admin.lic.ph.serial.input')" outlined hide-details clearable></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div>
              <v-btn color="primary" :disabled="serialEmpty" @click="applyLicense" x-small class="apply-btn"> <v-icon small style="padding-right:10px">mdi-file-replace</v-icon>{{ $t('admin.lic.apply.license') }} </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
export default {
  data() {
    return {
      license: {},
      serial: '',
      serialEmpty: true,
    };
  },
  computed: {
    endDate() {
      if (isEmpty(this.license)) return '';
      let expire = this.license.expiryDate;
      let rtn = `${expire[0]}-`;
      rtn += expire[1] < 10 ? `0${expire[1]}-` : `${expire[1]}-`;
      rtn += expire[2] < 10 ? `0${expire[2]}` : `${expire[2]}`;
      return rtn;
    },
    licenseFeatures() {
      if (isEmpty(this.license)) return '';
      return this.license.features.reduce((acc, elm, idx) => {
        if (idx == 0) return elm;
        return `${acc}, ${elm}`;
      }, '');
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    ...mapActions('common/auth', ['setResponseStatus']),
    async getLicense() {
      const { data } = await api.get('/admin/license');
      this.license = data;
    },
    changeSerial() {
      this.serialEmpty = isEmpty(this.serial) ? true : false;
    },
    async applyLicense() {
      const param = new URLSearchParams();
      param.append('cipherText', this.serial);
      const { status } = await api.post('/admin/license/update', param);
      if (status == 200) {
        // BEGIN::Added.by.KWShin.2025.04.21.
        // 라이선스가 갱신되었으므로 Store 'auth'의 status를 갱신하여 준다.
        this.setResponseStatus(status);
        // END::Added.by.KWShin.2025.04.21.
        this.getLicense();
        this.$snackbar(this.$t('common.processed'));
        this.serial = ''; // 성공적으로 라이선스가 갱신되었으므로 라이선스 시리얼은 화면에 보이지 않게 한다.
        this.serialEmpty = true;
      }
    },
  },
  async created() {
    this.getLicense();
  },
};
</script>

<style lang="scss" scoped>
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
.apply-btn {
  float: right;
  margin-top: 10px;
}
</style>
